export default __webpack_public_path__ + "static/media/cain10.06b65925.jpg";